import {
  useGetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab,
  useGetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab,
} from '@/shared/api/generated';

import type { EnrollmentHistory, PoloChangeHistory } from '../types/enrollment';
import { ENROLLMENT_CODE_TO_STATUS } from '../types/enrollmentStatusCode';

/**
 * Hook para carregar o histórico de status e de polo de uma matrícula.
 * Combina os endpoints `history-tab` e `polo-history-tab`.
 *
 * @param enrollmentId - ID da matrícula
 * @returns Histórico de status, histórico de polo e estado de loading/erro
 */
export function useEnrollmentHistory(enrollmentId: number) {
  const historyQuery =
    useGetApiV1CourseregistrationEnrollmentCourseregistrationidHistoryTab(enrollmentId);
  const poloQuery =
    useGetApiV1CourseregistrationEnrollmentCourseregistrationidPoloHistoryTab(enrollmentId);

  const history: readonly EnrollmentHistory[] = (historyQuery.data ?? []).map(
    (vm, index): EnrollmentHistory => ({
      ...vm,
      id: vm.id ?? index,
      oldStatus:
        vm.oldStatus !== undefined ? (ENROLLMENT_CODE_TO_STATUS[vm.oldStatus] ?? null) : null,
      newStatus:
        vm.newStatus !== undefined
          ? (ENROLLMENT_CODE_TO_STATUS[vm.newStatus] ?? 'payment_selection')
          : 'payment_selection',
    }),
  );

  const poloChanges: readonly PoloChangeHistory[] = poloQuery.data ?? [];

  return {
    history,
    poloChanges,
    isLoading: historyQuery.isLoading || poloQuery.isLoading,
    isError: historyQuery.isError || poloQuery.isError,
  } as const;
}
